import React from "react";
import StatsCards from "../ui/StatsCards";
import SummaryTable from "../ui/SummaryTable";
import PageHeader from "../ui/PageHeader";

function SummaryLayout({
  title,
  headerContent, 
  statsConfig,
  totals,
  statsLoading,
  formatter,
  tableProps,
  summary,
  extraContent,
  hasBackButton = false
}) {
  return (
    <div style={{ padding: 20 }}>

      <PageHeader title={title} hasBackButton={hasBackButton}>
        {headerContent}   
      </PageHeader>

      {statsConfig && (
        <div style={{ marginBottom: 10 }}>
          <StatsCards
            config={statsConfig}
            totals={totals}
            loading={statsLoading}
            formatter={formatter} 
          />
        </div>
      )}

      {extraContent}

      <SummaryTable
          {...tableProps}
          summary={summary}
      />
    </div>
  );
}

export default SummaryLayout;